// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__Lzoyp","arrowBlack":"Arrow_arrowBlack__wmv8X","arrowWhite":"Arrow_arrowWhite__QxX3Z","arrowBlackHeading":"Arrow_arrowBlackHeading__zX_Vi"};